/*
  VEYNOU - Trefferzahl im Lagermodus

  Problem: Auf einer Lager-Kollektion (Metafeld custom.nur_lagernd) stand im
  Filter-Panel und ueber dem Raster z. B. "14 von 80 Produkte", waehrend nur
  drei Karten zu sehen waren. Shopify zaehlt die Produkte, die den Filter
  treffen - also jedes Produkt mit irgendeiner Weissgold-Variante. Das Raster
  gibt im Lagermodus aber nur Karten aus, die in der gefilterten Farbe
  wirklich Bestand haben. Die Zahl war damit irrefuehrend.

  Loesung: Nach jedem Rendern die tatsaechlich sichtbaren Karten zaehlen
  (#product-grid > li) und in den Trefferanzeigen ausschliesslich die
  fuehrende Zahl ersetzen. Der Text drumherum ("von 80 Produkte" bzw. nur
  "Produkte") bleibt unangetastet.

  Der Eingriff ist bewusst auf den Lagermodus begrenzt: gearbeitet wird nur,
  wenn das Raster data-vy-stock="true" traegt. Das Attribut setzt
  sections/main-collection-product-grid.liquid nur bei vy_stock_only, und die
  Datei wird auch nur dort eingebunden. Fehlt das Attribut, passiert nichts.
*/
(function () {
  'use strict';

  /* Die drei Stellen, an denen das Theme die Zahl ausgibt: ueber dem Raster,
     im Kopf des Filter-Drawers und oben im mobilen Panel. Je nach Einstellung
     existieren nicht alle gleichzeitig. */
  var COUNT_IDS = ['ProductCount', 'ProductCountMobile', 'ProductCountDesktop'];

  /* Erste Zahl im Text, Tausenderpunkt eingeschlossen ("1.234"). Der Ausdruck
     endet vor dem naechsten Leerzeichen, greift also nie ueber "14" hinaus
     nach "von 80". */
  var LEADING_NUMBER = /\d+(?:[.,  ]\d{3})*/;

  var observer = null;
  var pending = false;
  var watched = [];

  function grid() {
    return document.getElementById('product-grid');
  }

  /* Der einzige Schalter. Ohne das Attribut - also auf jeder normalen
     Kollektion - bleibt die von Shopify gerenderte Zahl unveraendert. */
  function isStockMode() {
    var g = grid();
    return !!g && g.getAttribute('data-vy-stock') === 'true';
  }

  /* Nur direkte Kinder zaehlen: verschachtelte <li> in Karten (z. B. in einem
     Slider) wuerden die Zahl sonst verfaelschen. */
  function visibleCards() {
    var g = grid();
    if (!g) return -1;
    var n = 0;
    var child = g.firstElementChild;
    while (child) {
      if (child.tagName === 'LI') n++;
      child = child.nextElementSibling;
    }
    return n;
  }

  /* Ersetzt die fuehrende Zahl im ersten Textknoten, der ueberhaupt eine Zahl
     enthaelt. Ueber die Textknoten statt ueber innerHTML, damit umgebendes
     Markup erhalten bleibt. */
  function writeCount(el, n) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (!LEADING_NUMBER.test(node.nodeValue)) continue;
      var next = node.nodeValue.replace(LEADING_NUMBER, String(n));
      /* Nur schreiben, wenn sich wirklich etwas aendert. Sonst loest der
         eigene Schreibvorgang den MutationObserver erneut aus und der Lauf
         wiederholt sich endlos. */
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
  }

  function watch(el) {
    if (watched.indexOf(el) !== -1) return;
    watched.push(el);
    observer.observe(el, { childList: true, subtree: true, characterData: true });
  }

  function apply() {
    pending = false;
    if (!isStockMode()) return;
    var n = visibleCards();
    if (n < 0) return;
    for (var i = 0; i < COUNT_IDS.length; i++) {
      var el = document.getElementById(COUNT_IDS[i]);
      if (!el) continue;
      /* Das Theme schreibt die Zahl nach dem Raster neu: in facets.js laeuft
         renderProductCount() erst nach renderProductGridContainer(). Ohne
         Beobachtung der Anzeigen selbst wuerde die Server-Zahl den gerade
         gesetzten Wert sofort wieder ueberschreiben. */
      watch(el);
      writeCount(el, n);
    }
  }

  /* Mehrere Mutationen aus einem Rendervorgang zu einem Lauf buendeln. */
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(apply);
  }

  function boot() {
    observer = new MutationObserver(schedule);

    /* Beobachtet wird der Container, nicht das Raster: beim Filtern ersetzt
       facets.js #ProductGridContainer.innerHTML, das <ul id="product-grid">
       ist danach ein anderes Element - ein Beobachter am Raster waere tot.
       Der Container bleibt bestehen. Mit subtree deckt das beide Faelle ab:
       nachgeladene Karten beim Endlos-Scrollen (insertAdjacentHTML ans
       bestehende Raster) und das komplett neu gerenderte Raster nach einer
       Filteraenderung. */
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
